import { useState } from "react";

const baseURL = process.env.REACT_APP_BACKEND_URL || 
//"https://convohub-backend-0iiy.onrender.com/api/v1"
"https://api.crm.dalmlabs.com/api/v1"


export default function useCrmApi(
    endpoint: string,
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE",
    headers?: Record<string, any>,
    useSecretKey: boolean = true
) {
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState<any>(null);
    const [statusCode, setStatusCode] = useState(0);

    async function makeRequest(
        data?: any,
        params?: Record<string, any>,
        pathParam?: string
    ) {
        setLoading(true);

        const queryParams = new URLSearchParams(params || {}).toString();
        const urlWithParams = pathParam && queryParams
            ? `${baseURL}${endpoint}/${pathParam}?${queryParams}`
            : pathParam
                ? `${baseURL}${endpoint}/${pathParam}`
                : queryParams
                    ? `${baseURL}${endpoint}?${queryParams}`
                    : `${baseURL}${endpoint}`;

        const token = !useSecretKey ? localStorage.getItem("token") : null;

        try {
            const res = await fetch(urlWithParams, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                    ...headers,
                },
                body: ["POST", "PUT", "DELETE", "PATCH"].includes(method) && data
                    ? JSON.stringify(data)
                    : undefined,
            });

            const contentType = res.headers.get("content-type") || "";

            let result;
            if (contentType.includes("text/csv") || contentType.includes("text/plain")) {
                // ← This is the key fix for CSV export
                result = await res.text();
            } else {
                // Normal JSON response
                result = await res.json();
            }

            setResponse(result);
            setStatusCode(res.status);

            setLoading(false);
            return [result, res.status];

        } catch (error: any) {
         
            setLoading(false);
            return [{ error: error.message || "Request failed" }, 500];
        }
    }

    return { loading, makeRequest, response, statusCode };
}